import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { marked } from 'marked'

import { sanitize } from "../../helpers/sanitizationHelper"

const Typography = React.memo(function Typography({
    className: classNameProp,
    component: componentProp,
    children,
    content,
    ...other
}) {
    const className = classNames(classNameProp)

    const Component = componentProp || 'p'

    return (
        <Component className={className} {...other}>
            {content && <div dangerouslySetInnerHTML={{ __html: marked(sanitize(content)) }} />}
            {children}
        </Component>
    )
})

Typography.propTypes = {
    /**
   * The content of the component.
   */
    /**
   * @ignore
   */
    className: PropTypes.string,
    children: PropTypes.any,
    /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    content: PropTypes.any
}

Typography.defaultProps = {
    className: '',
    component: 'p',
}

export default Typography
